import { render, staticRenderFns } from "./UserFlagsList.vue?vue&type=template&id=00f8daa0&scoped=true"
import script from "./UserFlagsList.vue?vue&type=script&lang=ts"
export * from "./UserFlagsList.vue?vue&type=script&lang=ts"
import style0 from "./UserFlagsList.vue?vue&type=style&index=0&id=00f8daa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f8daa0",
  null
  
)

export default component.exports